import { render, staticRenderFns } from "./dataManagementList.vue?vue&type=template&id=89f3d95e&scoped=true"
import script from "./dataManagementList.vue?vue&type=script&lang=js"
export * from "./dataManagementList.vue?vue&type=script&lang=js"
import style0 from "./dataManagementList.vue?vue&type=style&index=0&id=89f3d95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f3d95e",
  null
  
)

export default component.exports